import axios from "axios";

export const TEACHER_URL = "/Teacher";
export const ADVISOR_URL = "/Advisor";

/** Belli Bir Danışman Öğretmen Listesini Elde Eder */
export function getAdvisors(queryParams) {
  return axios.post(`${ADVISOR_URL}/GetAdvisors`, queryParams);
}

/** Belli Bir Danışman Öğretmen Listesini Sayfalama Olmadan Elde Eder */
export function getAllAdvisors(queryParams) {
  return axios.post(`${ADVISOR_URL}/GetAllAdvisors`, queryParams);
}

/** Belli Bir Dönemde Sözleşmesi Olan Öğretmen Listesini Elde Eder */
export function getTeachers(term) {
  return axios.get(`${TEACHER_URL}/GetTeachers/${term}`);
}

/** Belli Bir Dönemde Sözleşmesi Olan Öğretmen Listesini Branşlarıyla Birlikte Elde Eder */
export function getTeachersWithBranches(term) {
  return axios.get(`${TEACHER_URL}/GetTeachersWithBranches/${term}`);
}

/** Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${ADVISOR_URL}/GetStudents`, queryParams);
}

/** Belli Bir Öğretmenin Belli Bir Dönemdeki Danışman Öğrencilerinin Kayıt Id lerini Elde Eder */
export function getRegistrationInfoIds(teacherId, term) {
  return axios.get(`${ADVISOR_URL}/${teacherId}/${term}`);
}

/** Belli Bir Danışman Öğrenci Listesini Kaydeder */
export function saveAdvisorStudents(entityId, term, ids) {
  return axios.post(ADVISOR_URL, { entityId, term, ids });
}

/** Belli Bir Danışman Öğretmen Listesini Siler */
export function deleteAdvisors(ids) {
  return axios.post(`${ADVISOR_URL}/Delete`, ids);
}